interface GetCurrencySymbolOptions {
  withSpace?: boolean;
}

export const getCurrencySymbol = (
  currencyCode: string,
  options?: GetCurrencySymbolOptions,
) => {
  const space = options?.withSpace ? ' ' : '';
  return (
    new Intl.NumberFormat('en', {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
      .format(0)
      .replace(/[0-9]/g, '')
      .trim() + space
  );
};
